export const getDefaultValues = (gatewayJoinProfileDetails) => ({
  GatewayJoinGatewayProfileAccessToken: gatewayJoinProfileDetails?.GatewayJoinGatewayProfileAccessToken || '',

  GatewayJoinGatewayProfileGatewayProfileID: gatewayJoinProfileDetails?.GatewayJoinGatewayProfileGatewayProfileID || 0,

  GatewayJoinGatewayProfileGatewayID: gatewayJoinProfileDetails?.GatewayJoinGatewayProfileGatewayID || 0,

  GatewayJoinGatewayProfileGatewayJoinGatewayProfileActiveTypeID:
    gatewayJoinProfileDetails?.GatewayJoinGatewayProfileGatewayJoinGatewayProfileActiveTypeID || 0,

  GatewayJoinGatewayProfileMinAmout: gatewayJoinProfileDetails?.GatewayJoinGatewayProfileMinAmout || 0,

  GatewayJoinGatewayProfileMaxAmount: gatewayJoinProfileDetails?.GatewayJoinGatewayProfileMaxAmount || 0,

  GatewayJoinGatewayProfileActiveDays: gatewayJoinProfileDetails?.GatewayJoinGatewayProfileActiveDays || 0,
});
